import React from "react";
import PropTypes from "prop-types";
import ReactRouterPropTypes from "react-router-prop-types";
import { withRouter } from "react-router-dom";

const LinkButton = ({
  history,
  location,
  match,
  to,
  staticContext,
  onClick,
  ...rest
}) => (
  <button
    type="button"
    {...rest}
    onClick={event => {
      if (onClick) {
        onClick(event);
      }
      history.push(to);
    }}
  />
);

LinkButton.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  staticContext: PropTypes.shape({})
};

LinkButton.defaultProps = {
  onClick: null,
  staticContext: null
};

export default withRouter(LinkButton);
